import { FAQ_DATA } from "@/lib/constants";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function FAQ() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-[#1A1A1A] text-center tracking-tight mb-12 md:mb-16">
          {FAQ_DATA.heading}
        </h2>

        <div
          ref={ref}
          className={`transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQ_DATA.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-gray-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-base font-semibold text-[#1A1A1A] py-5 hover:no-underline hover:text-[#20611B] transition-colors"
                  data-testid={`faq-trigger-${i}`}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#6B7280] leading-relaxed pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
